import { ButtonLink } from '@asgard/ui-library';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import ServiceEventTracking from 'services/service.event-tracking';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHeader,
  StyledIcon,
  StyledWrapper
} from './DailyContact.styled';

const DailyContact: React.FC = () => {
  const { t } = useI18n('manfred-daily');

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <StyledIcon>
            <img
              src={getPublicPath('/images/isotype-manfred-white.svg')}
              alt=""
            />
            <span>{t('manfred-daily.contact.icon')}</span>
          </StyledIcon>
          <Heading2 editorial>{t('manfred-daily.contact.title')}</Heading2>
          <p>
            <HtmlTrans
              ns="manfred-daily"
              i18nKey="manfred-daily.contact.desc"
            />
          </p>

          <ButtonLink
            schema="brand1"
            variant="hard"
            label={t('manfred-daily.contact.cta')}
            href="https://getmanfred.typeform.com/to/gKjXJi"
            target="_blank"
            endIcon={faArrowRight}
            onClick={() => {
              ServiceEventTracking.trackLandingCtaClicked(
                'manfred-daily-contacta-typeform'
              );
            }}
          />
        </StyledHeader>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default DailyContact;
